// @flow
'use strict'

const assign /*: <A: Object>(A) => <B: $ReadOnly<Object>>(B) => B */ = props => object =>
  Object.assign({}, object, props)

const bind /*: (* => *, * => * => *) => * => * */ = (f, g) => o => g(f(o))(o)

/*::
type UnregisterCallback = () => void
type CallbackList = Array<(...args: mixed[]) => mixed>
type CallbackRegistrar = CallbackList => ((...args: mixed[]) => mixed) => UnregisterCallback
*/
const registrar /*: CallbackRegistrar */ = list => fn => {
  list.push(fn)
  return () => {
    const index = list.indexOf(fn)
    if (index >= 0) {
      list.splice(index, 1)
    }
  }
}

module.exports.assign = assign
module.exports.bind = bind
module.exports.registrar = registrar



// WEBPACK FOOTER //
// ./record-store/utils.js